import axios from "../index"

// 接口基础路径
const rootApi = '/api_v2/production/progress'

/** 进度汇报 */
export const progressReport = (params1,params2,params3,params4,params5) => {
  return axios.post(`${rootApi}/reportProgress`, params1,params2,params3,params4,params5)
}

// /** 获取当前进度 */
// export const getProgress = (params) => {
//   return axios.get(`${rootApi}/getProgress`, {params})
// }

